import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import './LomavisDropdown1.css';

export type LomavisDropdown1Option = {
  value: string;
  label: React.ReactNode;
};

export type LomavisDropdown1Props = {
  options: LomavisDropdown1Option[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
};

/** A rounded single-select dropdown introduced for the communications UI. */
export const LomavisDropdown1: React.FC<LomavisDropdown1Props> = ({
  options,
  value,
  onChange,
  disabled = false,
  ariaLabel,
  className
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const selected = options.find((option) => option.value === value);

  return (
    <div className={className}>
      <Dropdown
        show={showDropdown}
        onToggle={(nextShow, metadata) => {
          if (metadata.source !== 'click') setShowDropdown(nextShow);
        }}
      >
        <Dropdown.Toggle
          bsPrefix="lomavis-dropdown1-toggle"
          variant="light"
          disabled={disabled}
          aria-label={ariaLabel}
          className="d-flex w-100 align-items-center justify-content-between gap-2 rounded-pill border bg-white px-3 py-2 text-start shadow-none"
          onClick={(event) => {
            event.stopPropagation();
            setShowDropdown((isOpen) => !isOpen);
          }}
        >
          <span className="text-truncate">{selected?.label ?? value}</span>
          <i className="fa-solid fa-chevron-down fs-8 text-muted" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="lomavis-dropdown1-menu w-100 border-0 p-2 shadow">
          {options.map((option) => (
            <Dropdown.Item
              key={option.value}
              active={option.value === value}
              onClick={() => {
                onChange(option.value);
                setShowDropdown(false);
              }}
              className="rounded-3 px-3 py-2 fw-semibold"
            >
              {option.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
